import axios, { AxiosResponse } from 'axios';

const defaultOptions = {
  headers: {
    'Content-Type': 'application/json',
    accept: 'text/html',
  },
};
export const instance = axios.create(defaultOptions);

export const setupInterceptors = () => {
  instance.interceptors.response.use(
    (res) => {
      // success
      return res;
    },
    async (err) => {
      return Promise.reject(err);
    },
  );
};

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') ?? '{}';
    config!.headers!.Authorization = token ? `Bearer ${token}` : '';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const responseBody = (response: AxiosResponse) => response.data;

export const requests = {
  get: (url: string, params?: any) =>
    instance
      .get(url, { params })
      .then(responseBody)
      .catch((e) => {
        throw e;
      }),
  post: (url: string, body: {}, customHeaders?: any) =>
    instance
      .post(url, body, customHeaders)
      .then(responseBody)
      .catch((e) => {
        throw e;
      }),
  put: (url: string, body: {}, customHeaders?: any) =>
    instance
      .put(url, body, customHeaders)
      .then(responseBody)
      .catch((e) => {
        throw e;
      }),
  patch: (url: string, body: {}, customHeaders?: any) =>
    instance
      .patch(url, body, customHeaders)
      .then(responseBody)
      .catch((e) => {
        throw e;
      }),
  delete: (url: string) =>
    instance
      .delete(url)
      .then(responseBody)
      .catch((e) => {
        throw e;
      }),
};

export async function multipartFormData(
  image: any,
  url: string,
  body?: any,
  bodyKeys?: string[],
  method = 'put',
  formKey = 'file',
  isMultiple = false,
  progressCallback?: (progress: number) => void,
) {
  const formData = new FormData();
  if (isMultiple) {
    for (const item of image) {
      formData.append(formKey, item);
    }
  } else {
    formData.append(formKey, image);
  }
  for (const item of bodyKeys || []) {
    formData.append(item, body[item]);
  }
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };

  switch (method) {
    case 'put':
      return instance.put(url, formData, config);
    case 'patch':
      return instance.patch(url, formData, config);
    default:
      return instance.post(url, formData, config);
  }
}

export const formDataHeaders = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};
